import styled from 'styled-components'

export const NavigationWrapper = styled.div`
    padding-top: 3.75rem;
`
